(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stage-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mfn-timeline')) {
    class MfnTimeline extends HTMLElement {
      connectedCallback() {
        this.stages = Array.from(this.querySelectorAll('[data-mfn-stage]'));
        if (!this.stages.length) return;

        this.collapsible = this.dataset.collapsible === 'true';
        this.fallback = Math.max(0, (parseInt(this.dataset.default, 10) || 1) - 1);
        this.current = this.stages.findIndex(function (stage) { return stage.classList.contains('is-active'); });
        this.mobile = window.matchMedia('(max-width: 989.98px)');

        this.onClick = this.onClick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);

        this.addEventListener('click', this.onClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        if (this.mobile.addEventListener) {
          this.mobile.addEventListener('change', this.onLayoutChange);
        } else if (this.mobile.addListener) {
          this.mobile.addListener(this.onLayoutChange);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (!this.mobile) return;
        if (this.mobile.removeEventListener) {
          this.mobile.removeEventListener('change', this.onLayoutChange);
        } else if (this.mobile.removeListener) {
          this.mobile.removeListener(this.onLayoutChange);
        }
      }

      onClick(event) {
        var target = event.target.closest('[data-mfn-select]');
        if (!target) return;
        var index = this.stages.findIndex(function (stage) { return stage.contains(target); });
        if (index < 0) return;
        this.classList.add('is-interacted');
        // On mobile the open row can optionally be closed by tapping it again.
        if (index === this.current && this.collapsible && this.mobile.matches) {
          this.show(-1);
        } else {
          this.show(index);
        }
      }

      onBlockSelect(event) {
        var index = this.stages.findIndex(function (stage) { return stage.contains(event.target); });
        if (index >= 0) this.show(index);
      }

      onLayoutChange() {
        // Desktop always needs one stage open.
        if (!this.mobile.matches && this.current === -1) this.show(this.fallback);
      }

      show(index) {
        this.stages.forEach(function (stage, i) {
          var open = i === index;
          var trigger = stage.querySelector('.mfn__trigger');
          var panel = stage.querySelector('.mfn__panel');
          stage.classList.toggle('is-active', open);
          if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (panel) panel.hidden = !open;
        });
        this.current = index;
      }
    }
    customElements.define('mfn-timeline', MfnTimeline);
  }

  } catch(e) { console.error(e); }
})();
})();
